<template>
    <span class="ath-visual-icon">
        <span class="el-stencil el--t-icon"></span>
    </span>
</template>

<script>
export default {
    name: 'mead-icon-stencil',
};
</script>
